<template>
  <div>
    <shared-table :config="config" />
  </div>
</template>

<script>
import SharedTable from '@/views/admin/pages/SharedTable'
import PagesTableConfig from './config/pages-table-config'

export default {
  components: {
    SharedTable,
  },
  data() {
    return {
      config: PagesTableConfig,
    }
  },
  mounted() {
    this.$store.dispatch('pages/GET_PAGE_FEATURES')
  },
}
</script>
